import { ApiService } from '../../../services/api.service';
import { Chart } from 'chart.js';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { AuthenticationService } from "../../../services/authentication.service";
import { TranslateService } from '@ngx-translate/core';
var DashboardListComponent = (function () {
    function DashboardListComponent(apiService, router, authService, translate) {
        this.apiService = apiService;
        this.router = router;
        this.authService = authService;
        this.translate = translate;
        // month amount to show in graph
        this.monthAmount = 6;
        // activity amount to show in activity list
        this.activityAmount = 2;
        this.monthList = [];
        this.monthListDropdown = [
            { label: 'มกราคม', value: 1 },
            { label: 'กุมภาพันธ์', value: 2 },
            { label: 'มีนาคม', value: 3 },
            { label: 'เมษายน', value: 4 },
            { label: 'พฤษภาคม', value: 5 },
            { label: 'มิถุนายน', value: 6 },
            { label: 'กรกฎาคม', value: 7 },
            { label: 'สิงหาคม', value: 8 },
            { label: 'กันยายน', value: 9 },
            { label: 'ตุลาคม', value: 10 },
            { label: 'พฤศจิกายน', value: 11 },
            { label: 'ธันวาคม', value: 12 }
        ];
        this.SelectBashboard = [
            { label: 'Documents Dashboard', value: 1 },
            { label: 'Emails Dashboard', value: 2 }
        ];
        this.yearList = [];
        this.selectedDate = new Date();
        this.charts_bar_stacked = null;
        this.charts_signing_counter_bar_stacked = null;
        this.charts_signing_counter_line = null;
        this.chartLabels = [];
        this.monthly_loading = false;
        this.daily_loading = false;
        this.bar_stacked_title = '';
        this.charts_signing_counter_bar_stacked_title = '';
        this.charts_transaction_count_title = '';
        if (this.authService.isAccountantTH() || this.authService.isAccountantINC()) {
            this.router.navigate(['/taxReport']);
        }
    }
    DashboardListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadGraph();
        this.loadActivity();
        this.loadMonthlyData();
        this.loaddashboard();
        this.translate.get('COMMON.ALL').subscribe(function () {
            _this.populateDropdown();
            _this.loadMonthList();
            _this.loadMonthlyData();
        });
        this.translate.onLangChange.subscribe(function (event) {
            _this.loadMonthList();
            _this.loadMonthlyData();
            _this.loaddashboard();
        });
    };
    DashboardListComponent.prototype.loaddashboard = function () {
        this.keepdashboard = null;
        this.dashboards = [
            { label: this.translate.instant('DASHBOARD.TITLE'),
                value: null },
            // {label: this.translate.instant('DASHBOARD.SMS'), value: 2},
            { label: this.translate.instant('MENU.EMAIL-DASHBOARD'), value: 2 },
        ];
    };
    DashboardListComponent.prototype.choosedashboard = function () {
        this.keepdashboard = this.selectDashboard;
    };
    DashboardListComponent.prototype.loadMonthList = function () {
        this.monthList = [];
        this.monthList.push(this.translate.instant('MONTH.JANUARY'), this.translate.instant('MONTH.FEBRUARY'), this.translate.instant('MONTH.MARCH'), this.translate.instant('MONTH.APRIL'), this.translate.instant('MONTH.MAY'), this.translate.instant('MONTH.JUNE'), this.translate.instant('MONTH.JULY'), this.translate.instant('MONTH.AUGUST'), this.translate.instant('MONTH.SEPTEMBER'), this.translate.instant('MONTH.OCTOBER'), this.translate.instant('MONTH.NOVEMBER'), this.translate.instant('MONTH.DECEMBER'));
    };
    DashboardListComponent.prototype.populateDropdown = function () {
        var _this = this;
        this.company = [{
                label: 'ทั้งหมด',
                value: null
            }];
        this.apiService.getCompany().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name + ' (' + obj.short_name + ')',
                    value: obj.id
                });
            });
        });
        this.homeproGroup = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompanyGroup().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.homeproGroup.push({
                    label: obj.name + ' (' + obj.short_name + ')',
                    value: obj.id
                });
            });
        });
        var currentDate = new Date();
        // populate year list back within 10 years
        var thisYear = currentDate.getFullYear();
        for (var i = 0; i <= 10; i++) {
            this.yearList.push({ label: (thisYear - i).toString(), value: thisYear - i });
        }
        // set current month and year
        this.selectedMonth = currentDate.getMonth() + 1;
        this.selectedYear = thisYear;
    };
    DashboardListComponent.prototype.loadGraph = function () {
        var currentDate = new Date();
        var year = currentDate.getFullYear();
        var month = currentDate.getMonth() - this.monthAmount + 2;
        while (month <= 0) {
            year--;
            month += 12;
        }
        // populate chart label by month and year
        for (var i = 0; i < this.monthAmount; i++, month++) {
            if (month > 12) {
                month = 1;
                year++;
            }
            this.chartLabels.push(month + '/' + year);
        }
        // get graph data from API
        var data = {
            month_amount: this.monthAmount
        };
        this.apiService.getDashboardLengthData(data).subscribe(function (obj) {
        });
    };
    // load data from current month
    DashboardListComponent.prototype.loadMonthlyData = function () {
        var _this = this;
        var data = {
            year: this.selectedYear
        };
        if (this.selectedCompany != null)
            data['company_id'] = this.selectedCompany;
        if (this.selectedHomeproGroup != null)
            data['group_id'] = this.selectedHomeproGroup;
        this.monthly_loading = true;
        this.apiService.getDashboardMonthlyData(data).subscribe(function (obj) {
            _this.monthly_loading = false;
            _this.create_signing_counter_bar_stacked(obj.signing_counter);
            Chart.plugins.register({
                beforeDraw: function (chart) {
                    if (chart.config.options.elements.center) {
                        chart.clear();
                        //Get ctx from string
                        var ctx = chart.chart.ctx;
                        //Get options from the center object in options
                        var centerConfig = chart.config.options.elements.center;
                        var fontStyle = centerConfig.fontStyle || 'Arial';
                        var txt = centerConfig.text;
                        var color = centerConfig.color || '#000';
                        var sidePadding = centerConfig.sidePadding || 20;
                        var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);
                        //Start with a base font of 30px
                        ctx.font = "30px " + fontStyle;
                        var stringWidth = ctx.measureText(txt).width;
                        var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;
                        // Find out how much the font can grow in width.
                        var widthRatio = elementWidth / stringWidth;
                        var newFontSize = Math.floor(30 * widthRatio);
                        var elementHeight = (chart.innerRadius * 2);
                        // Pick a new font size so it will not be larger than the height of label.
                        var fontSizeToUse = Math.min(newFontSize, elementHeight);
                        //Set font settings to draw it correctly.
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'middle';
                        var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
                        var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 1.2);
                        ctx.font = fontSizeToUse + "px " + fontStyle;
                        ctx.fillStyle = color;
                        //Draw text in center
                        ctx.fillText(txt, centerX, centerY);
                    }
                },
                afterDraw: function (chart) {
                    if (chart.data.datasets.length === 0) {
                        // No data is present
                        var ctx = chart.chart.ctx;
                        var width = chart.chart.width;
                        var height = chart.chart.height;
                        chart.clear();
                        ctx.save();
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'middle';
                        ctx.font = "14pt Tahoma";
                        ctx.fillStyle = '#000';
                        ctx.fillText('ไม่ข้อมูลแสดง', width / 2, height / 2);
                        ctx.restore();
                    }
                }
            });
        });
    };
    DashboardListComponent.prototype.create_signing_counter_bar_stacked = function (data) {
        var receipt_tax_invoice = data.receipt_tax_invoice;
        var credit_note = data.credit_note;
        var debit_note = data.debit_note;
        var delivery_order_tax_invoice = data.delivery_order_tax_invoice;
        var color = Chart.helpers.color;
        this.charts_signing_counter_bar_stacked_title = 'จำนวนครั้งการ Sign รายเดือน';
        var barChartData = {
            labels: this.monthList,
            datasets: [{
                    label: this.translate.instant('TEXT.RTI'),
                    backgroundColor: color("rgb(54, 162, 235)").alpha(0.5).rgbString(),
                    borderColor: "rgb(54, 162, 235)",
                    data: receipt_tax_invoice
                }, {
                    label: this.translate.instant('TEXT.DO'),
                    backgroundColor: color("rgb(80, 200, 120)").alpha(0.5).rgbString(),
                    borderColor: "rgb(80, 200, 120)",
                    data: delivery_order_tax_invoice
                }, {
                    label: this.translate.instant('TEXT.CN'),
                    backgroundColor: color("rgb(255, 159, 64)").alpha(0.5).rgbString(),
                    borderColor: "rgb(255, 159, 64)",
                    data: credit_note
                }, {
                    label: this.translate.instant('TEXT.DN'),
                    backgroundColor: color("rgb(255, 99, 132)").alpha(0.5).rgbString(),
                    borderColor: "rgb(255, 99, 132)",
                    data: debit_note
                }]
        };
        if (this.charts_signing_counter_bar_stacked == null) {
            this.charts_signing_counter_bar_stacked = new Chart('signing-counter-bar-chart', {
                type: 'bar',
                data: barChartData,
                options: {
                    tooltips: {
                        titleFontSize: 17,
                        bodyFontSize: 17,
                        mode: 'index',
                        intersect: false,
                        callbacks: this.getformatLabelFunction(this.translate.instant('COMMON.TIMES'), true)
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                                stacked: true,
                            }],
                        yAxes: [{
                                stacked: true,
                                ticks: {
                                    beginAtZero: true,
                                    callback: function (value) {
                                        if (value % 1 === 0) {
                                            return value;
                                        }
                                    }
                                }
                            }]
                    },
                    legend: {
                        position: 'top',
                    }
                }
            });
        }
        else {
            this.charts_signing_counter_bar_stacked.config.options.tooltips.callbacks = this.getformatLabelFunction(this.translate.instant('COMMON.TIMES'), true);
            this.charts_signing_counter_bar_stacked.data = barChartData;
            this.charts_signing_counter_bar_stacked.update();
        }
    };
    DashboardListComponent.prototype.loadActivity = function () {
        var _this = this;
        var data = {
            amount: this.activityAmount
        };
        this.apiService.getDashboardActivity(data).subscribe(function (obj) {
            _this.activityList = obj;
        }, function (error) {
        });
    };
    DashboardListComponent.prototype.formatCurrency = function (currency) {
        return parseFloat(currency).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    };
    DashboardListComponent.prototype.getformatLabelFunction = function (unitName, showSum) {
        var _this = this;
        var tooltip = {
            label: function (tooltipItem, data) {
                var dataLabel = data.datasets[tooltipItem.datasetIndex].label;
                if (dataLabel == null) {
                    dataLabel = data.labels[tooltipItem.index];
                }
                var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                var valueStr = ' : ' + value.toLocaleString();
                if (value >= 2 && unitName === 'Time') {
                    dataLabel += valueStr + ' ' + unitName + 's';
                }
                else {
                    dataLabel += valueStr + ' ' + unitName;
                }
                if (showSum)
                    window['total'] += value;
                return dataLabel;
            }
        };
        if (showSum) {
            tooltip['afterTitle'] = function () {
                window['total'] = 0;
            };
            tooltip['footer'] = function (tooltipItem, data) {
                var text = [_this.translate.instant('CHART.TOTAL') + ' : ' + window['total'].toLocaleString() + ' ' + unitName +
                        ((window['total'] >= 2 && unitName === 'Time') ? 's' : '')];
                return tooltipItem.length ? text : null;
            };
        }
        return tooltip;
    };
    return DashboardListComponent;
}());
export { DashboardListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-list/dashboard-list.component.ts.pre-build-optimizer.js